import { set } from 'date-fns';

import { Row } from '../../../../../coaching-observation/experimental.grid';
import { PayloadAction } from '../../../../../store.model';
import { ActionType } from '../commitment-narrative.action';
import { CellContext, RowContext } from '../commitment-narrative.model';
import { State } from '../commitment-narrative.state';
import { DateFilterType } from '../models/data-filter-type.enum';

import { Reload } from './reload.action';

export function reloadReducer(
    state: State,
    action: PayloadAction<ActionType, Reload>,
): State {
    if (action.payload.rows == null || action.payload.rows.length === 0) {
        return {
            ...state,
            pending: {},
            rows: [],
            filteredRow: [],
        };
    }

    const rows = action.payload.rows;
    const { creatorsSet, updatersSet, minCreatedDate, minUpdatedDate } =
        processRows(rows);
    const filterCreators = Array.from(creatorsSet);
    const filterUpdaters = Array.from(updatersSet);
    const to = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(to.getDate() - 30);

    const fromCreated = getFromDate(minCreatedDate, thirtyDaysAgo);
    const fromUpdated = getFromDate(minUpdatedDate, thirtyDaysAgo);

    return {
        ...state,
        pending: {
            ...state.pending,
            reload: false,
        },
        rows,
        filteredRow: rows,
        filterOpts: {
            createdRange: {
                from: fromCreated,
                to,
            },
            lastUpdatedOnRange: {
                from: fromUpdated,
                to,
            },
            enabledFilters: {
                [DateFilterType.Created]: false,
                [DateFilterType.LastUpdated]: false,
            },
        },
        filterCreators,
        filterUpdaters,
    };
}

function processRows(rows: Array<Row<RowContext, CellContext>>): {
    minCreatedDate: Date | null;
    minUpdatedDate: Date | null;
    creatorsSet: Set<string>;
    updatersSet: Set<string>;
} {
    const creatorsSet = new Set<string>();
    const updatersSet = new Set<string>();
    let minCreatedDate: Date | null = null;
    let minUpdatedDate: Date | null = null;

    rows.forEach((row) => {
        if (row.ctx != null) {
            addCreatorsAndUpdaters(row, creatorsSet, updatersSet);
            minCreatedDate = processDate(row.ctx.date, minCreatedDate);
            minUpdatedDate = processDate(row.ctx.lastUpdatedOn, minUpdatedDate);
        }
    });

    return { creatorsSet, updatersSet, minCreatedDate, minUpdatedDate };
}

function addCreatorsAndUpdaters(
    row: Row<RowContext, CellContext>,
    creatorsSet: Set<string>,
    updatersSet: Set<string>,
): void {
    creatorsSet.add(row.ctx.createdBy);
    if (row.ctx.lastUpdatedBy != null && row.ctx.lastUpdatedBy !== '') {
        updatersSet.add(row.ctx.lastUpdatedBy);
    }
    if (row.ctx.createdBy != null) {
        updatersSet.add(row.ctx.createdBy);
    }
}

function processDate(dateString: Date, minDate: Date): Date {
    if (dateString != null)
        if (dateString != null) {
            const originalDate = new Date(dateString);
            const dateWithoutTime = set(originalDate, {
                hours: 0,
                minutes: 0,
                seconds: 0,
                milliseconds: 0,
            });
            minDate = getMinStartDate(minDate, dateWithoutTime);
        }
    return minDate;
}

function getMinStartDate(
    minStartDate: Date | null,
    rowDate: Date,
): Date | null {
    if (minStartDate == null) return rowDate;
    return rowDate < minStartDate ? rowDate : minStartDate;
}

function getFromDate(minDate: Date | null, thirtyDaysAgo: Date): Date {
    return minDate != null && minDate < thirtyDaysAgo ? minDate : thirtyDaysAgo;
}
